const calculateScaling = (pageWidth, containerWidth) => {
  const container = containerWidth || pageWidth;
  const scale = container / pageWidth;
  return scale;
};

export { calculateScaling };